import React from "react";
import styled from "styled-components/macro";
import { ConfirmDialog } from "../../components/shared";
import { OwcTypography, OwcButton } from "@one/react";

/* ---------- styled-components ---------- */
const InfoWrapper = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: #0B41CD;
  position: absolute;
  z-index: 9999;
  font-weight: 500;
  margin-top: 20px;
  margin-left: 15px;
`;

const InfoLink = styled.a`
  font-size: 14px;
  line-height: 20px;
  color: #0B41CD;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

const CidmGroupDialog = ({
  open,
  onClose,
  groupName = "-",
  cidmUrl = "",
  infoUrl = "",
}) => {
  const handleGoToCidm = () => {
    if (cidmUrl) window.open(cidmUrl, "_blank", "noreferrer");
    onClose();
  };
  return (
    <ConfirmDialog
      open={open}
      close={onClose}
      title={<OwcTypography variant="h6">Training requirement</OwcTypography>}
      content={
        <>
          <OwcTypography variant="body1" gutterBottom>
            To book this instrument you need to be in CIDM Group{" "}
            <strong>{groupName}</strong>.
            <br />
            Click to request access and make sure to complete any training
            associated.
          </OwcTypography>
          <InfoWrapper>
            <InfoLink href={infoUrl} target="_blank" rel="noreferrer">
              More info
            </InfoLink>
          </InfoWrapper>
        </>
      }
      approveText="Go to CIDM"
      approveColor="primary"
      approveVariant="contained"
      onApprove={handleGoToCidm}
      cancelText="Cancel"
      cancelColor="default"
      onCancel={onClose}
      renderActions={({ cancelColor, cancelVariant, approveColor, approveVariant, cancelText, approveText }) => (<div style={{ display: "flex", marginLeft: "auto" }}>
          <OwcButton
            variant="secondary"
            onClick={onClose}
            style={{ marginRight: 32 }}
            >
            {cancelText}
          </OwcButton>
           <OwcButton
            variant="primary"
            onClick={handleGoToCidm}
            style={{ marginRight: "8px" }}
          >
            {approveText}
          </OwcButton>
        </div>
      )}
      maxWidth="sm"
      fullWidth
    />
  );
};

export default CidmGroupDialog;
